// extracted by mini-css-extract-plugin
module.exports = {"primaryMain":"#102431","secondaryMain":"#cfb57b"};